<template>
  <div>
    <v-layout wrap justify-center >
      <v-flex xs12 sm11>
        <v-card elevation="0">
          <v-layout wrap py-10 px-xs-0 px-sm-16 px-md-0 px-lg-6 px-xl-16>
            <v-flex xs12 sm11 px-xs-0 px-sm-0 px-md-16 px-lg-16 px-xl-16>
              <v-layout wrap>
                <v-flex xs12 text-left>
              <span
                style="
                  color: #000000;
                  font-size: 25px;
                  font-family: poppinssemibold;
                "
                >Product Reviews
              </span>
            </v-flex>
            <!--  -->
            <v-flex xs12 pt-5 v-for="(item, i) in reviewArray" :key="i">
              <v-layout wrap justify-start>
                <v-flex xs2 sm1 text-left>
                  <v-img
                    height="80px"
                    contain
                    src="./../../assets/icons/reviewuser.png"
                  ></v-img>
                </v-flex>
                <v-flex xs10 sm11 pl-5 pt-2 text-left>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-rating
                        color="#F28F34"
                        background-color="#F28F34"
                        half-increments
                        hover
                        v-model="item.rating"
                        small
                      ></v-rating>
                    </v-flex>
                    <v-flex xs12>
                      <span
                        style="
                          font-family: poppinsregular;
                          color: #000000;
                          font-size: 14px;
                        "
                        >{{ item.name }}</span
                      ><span
                        style="
                          color: #727272;
                          font-family: poppinsregular;
                          font-size: 12px;
                        "
                      >
                        <!-- - March 6,2023 -->
                        - {{item.reviewdate}}
                      </span>
                    </v-flex>
                    <v-flex xs12 pt-2>
                      <!-- <span style="font-family: opensansbold"
                        >Pure, Natural, and Delicious!</span
                      >
                      <br /> -->
                      <span
                        style="
                          color: #3c3c3c;
                          font-family: poppinsregular;
                          font-size: 13px;
                        "
                      >
                        <!-- This eco-friendly honey is absolutely fantastic! You can
                        taste the purity in every spoonful, knowing it's sourced
                        sustainably makes it even better. The rich flavor is
                        perfect for adding to my tea or drizzling over yogurt.
                        It's also great to support a product that's good for the
                        environment and my health. Highly recommend it to anyone
                        looking for a natural, high-quality honey! -->
                        {{ item.review }}
                      </span>
                    </v-flex>
                  </v-layout>
                  <v-flex xs12 pt-8>
                    <!-- v-if="i < reviews.length - 1" -->
                    <v-divider></v-divider>
                  </v-flex>
                  <!-- <v-flex xs12 pt-5>
                    <v-btn rounded @click="dialog=true" color="#444645" dark width="150px"
                      ><span
                        style="
                          font-family: poppinsmedium;
                          text-transform: none;
                          letter-spacing: 0px;
                        "
                        >Write a Review</span
                      ></v-btn
                    >
                  </v-flex> -->
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 v-if="!reviewArray.length>0" pt-5>
              <span style="font-family: poppinsregular;">No reviews found !</span>
            </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dialog" width="600px">
      <v-card>
        <v-layout wrap pa-5>
        <v-flex xs11 pb-2 text-left>
            <span
              style="
                font-family: poppinssemibold;
                font-size: 15px;
                color: #191919;
              "
            >
              Rate this product
            </span>
          </v-flex>
          <v-flex xs1 text-right class="pa-0">
            <v-icon color="red" @click="dialog=false">mdi-close</v-icon>
          </v-flex>
          <v-flex xs12 sm12 text-left>
            <v-rating
              color="#F28F34"
              background-color="#F28F34"
              half-increments
              size="30px"
              hover
              v-model="rating"
            ></v-rating>
          </v-flex>
          <v-flex xs12 py-2 text-left>
            <span
              style="
                font-family: poppinssemibold;
                font-size: 15px;
                color: #191919;
              "
            >
              Share your thoughts on this product.
            </span>
          </v-flex>
          <v-flex xs12 sm12 text-left>
            <v-textarea outlined rows="3" v-model="review"> </v-textarea>
          </v-flex>
          <v-flex xs12 text-right align-self-end pb-5>
            <v-btn color="#30B868" dark
              ><span style="font-family: opensanssemibold; text-transform: none;"
                >Post Review</span
              ></v-btn
            >
          </v-flex>
      </v-layout>
      </v-card>
    
    </v-dialog>
  </div>
</template>
<script>
import axios from 'axios';
export default {
  props: ["reviews"],
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      dialog:false,
      rate: "",
      rating:"",
      review:"",
      reviewArray:[],
    };
  },
  beforeMount() {
    this.getReview();
  },
  methods: {
    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      // var hours = dt.getHours();
      // var minutes = dt.getMinutes();
      dt = dt.toString();
      // var ampm = hours >= 12 ? "pm" : "am";
      // hours = hours % 12;
      // hours = hours ? hours : 12;
      // minutes = minutes < 10 ? "0" + minutes : minutes;
      // day = day < 10 ? "0" + day : day;
      var strTime = day + " " + dt.slice(4, 7) + " " + year;
      return strTime;
    },

    getReview() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/product/ListReview",
        params: {
          limit: this.limit,
          page: this.currentPage,
          productId: this.$route.query.id,
        },
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.reviewArray = response.data.data;  // Directly assigning the updated data structure
          this.pages = Math.ceil(response.data.totalLength / this.limit);
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

  },
};
</script>